import { useRef, useEffect } from 'react';
import * as monaco from 'monaco-editor';


const useMonacoEditor = (onChange) => {
  const editorRef = useRef();
  const editor = useRef();
  useEffect(() => {
    if (!editorRef.current) {
      return;
    }
    editor.current = monaco.editor.create(editorRef.current, {
      value: "# 在此处输入代码\n",
      language: "python",
      theme: "vs-dark",
      automaticLayout: true,
      fontSize: 18,
      lineNumbersMinChars: 3
    });
  }, []);
  const editorReLayout = () => editor.current && editor.current.layout();
  const resetEditor = () => editor.current && editor.current.setValue('');
  const getEditorCode = () => editor.current ? editor.current.getValue() : '';
  const setEditorCode = (code) => editor.current && editor.current.setValue(code);
  return { editor, editorRef, editorReLayout, resetEditor, getEditorCode, setEditorCode };
};

export default useMonacoEditor;
